import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

function Addcase() {
  const [userData, setUserData] = useState(null);
  const [firstname, setFirstname] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [cases, setCases] = useState("Settlement");
  const [casestatus, setCasestatus] = useState("Active");
  const [caseinfo, setCaseinfo] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [location, setLocation] = useState("");
  const [blotter, setBlotter] = useState("0");
  const [crime, setCrime] = useState("0");
  const [settled, setSettledcases] = useState("0");
  const [settlement, setUnsettlecases] = useState("0");
  const [allcases, setAllcases] = useState("0");

  const [currentPageUsers, setCurrentPageUsers] = useState(1);
  const [currentPageSelectedUsers, setCurrentPageSelectedUsers] = useState(1);
  const rowsPerPage = 5;

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://brgytracerappserver.onrender.com/addcase")
      .then((response) => {
        setBlotter(response.data.blotter);
        setCrime(response.data.crime);
        setSettledcases(response.data.settled);
        setUnsettlecases(response.data.settlement);
        setAllcases(response.data.allcases);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        `https://brgytracerappserver.onrender.com/listuser?firstname=${firstname}`
      )
      .then((res) => {
        setUserData(res.data);
      })
      .catch((err) => console.log(err));
  }, [firstname]);

  const handleAdd = (user) => {
    if (
      !selectedUsers.some((selectedUser) => selectedUser.brgyId === user.brgyId)
    ) {
      setSelectedUsers((prevSelectedUsers) => [
        ...prevSelectedUsers,
        { ...user, caseInfo: "" },
      ]);
    }
  };

  const handleRemove = (index) => {
    setSelectedUsers((prevSelectedUsers) => {
      const updatedUsers = [...prevSelectedUsers];
      updatedUsers.splice(index, 1);
      return updatedUsers;
    });
  };

  const handleSearchInputChange = (e) => {
    setFirstname(e.target.value);
  };

  const handleSubmitCases = () => {
    if (selectedUsers.length === 0) {
      Swal.fire({
        title: "Opps!",
        text: "Please select at least one user!",
        icon: "error",
      });
      return;
    }
    if (!cases || !casestatus || !date || !time || !location || !caseinfo) {
      Swal.fire({
        title: "Opps!",
        text: "Please fill all required fields!",
        icon: "error",
      });
      return;
    }

    const casesData = selectedUsers.map((user) => ({
      brgyId: user.brgyId,
      caseType: cases,
      date,
      time,
      location,
      casestatus,
      caseInfo: caseinfo,
    }));

    axios
      .post("https://brgytracerappserver.onrender.com/addcases", casesData)
      .then((res) => {
        if (res.data.status === "success") {
          Swal.fire({
            title: "Added Cases!",
            text: "Save Successfully!",
            icon: "success",
          }).then(() => {
            setSelectedUsers([]);
            setCases("Not Set");
            setCaseinfo("");
            setDate("");
            setTime("");
            setLocation("");
            setCasestatus("");
            window.location.reload();
          });
        }
      })
      .catch((err) => console.log(err));
  };

  const handleclose = () => {
    navigate("/officerpage");
  };

  const handlePreviousPageUsers = () => {
    setCurrentPageUsers((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPageUsers = () => {
    setCurrentPageUsers((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(userData.users.length / rowsPerPage))
    );
  };

  const handlePreviousPageSelectedUsers = () => {
    setCurrentPageSelectedUsers((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleNextPageSelectedUsers = () => {
    setCurrentPageSelectedUsers((prevPage) =>
      Math.min(prevPage + 1, Math.ceil(selectedUsers.length / rowsPerPage))
    );
  };

  const startIndexUsers = (currentPageUsers - 1) * rowsPerPage;
  const endIndexUsers = startIndexUsers + rowsPerPage;
  const currentUsers = userData
    ? userData.users.slice(startIndexUsers, endIndexUsers)
    : [];

  const startIndexSelectedUsers = (currentPageSelectedUsers - 1) * rowsPerPage;
  const endIndexSelectedUsers = startIndexSelectedUsers + rowsPerPage;
  const currentSelectedUsers = selectedUsers.slice(
    startIndexSelectedUsers,
    endIndexSelectedUsers
  );

  return (
    <div className="addcase-parent-holder parent-height">
      <div className="container-box">
        <div className="searchbox">
          <div>
            <FontAwesomeIcon icon={faSearch} />
            <input
              type="text"
              placeholder="Search by FirstName"
              value={firstname}
              onChange={handleSearchInputChange}
            />
          </div>
        </div>
        <div className="grid-holder">
          <div className="grid-container">
            <h1>List of Users</h1>
            {currentUsers.length > 0 ? (
              <div className="datagrid-holder">
                <table>
                  <thead>
                    <tr>
                      <th>BrgyId</th>
                      <th>First Name</th>
                      <th>Family Name</th>
                      <th>Gender</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentUsers.map((user, index) => (
                      <tr key={`${user.brgyId}-${index}`}>
                        <td>{user.brgyId}</td>
                        <td>{user.firstname}</td>
                        <td>{user.lastname}</td>
                        <td>{user.gender}</td>
                        <td
                          className="handleEdit"
                          onClick={() => handleAdd(user)}>
                          Add
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-controls">
                  <button
                    className="pagination-button"
                    onClick={handlePreviousPageUsers}
                    disabled={currentPageUsers === 1}>
                    Previous
                  </button>
                  <span className="pagination-info">
                    Page {currentPageUsers} of{" "}
                    {Math.ceil(userData.users.length / rowsPerPage)}
                  </span>
                  <button
                    className="pagination-button"
                    onClick={handleNextPageUsers}
                    disabled={
                      currentPageUsers ===
                      Math.ceil(userData.users.length / rowsPerPage)
                    }>
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <p className="noUsertext">No users available for display.</p>
            )}
          </div>
          {/* Second grid */}
          <div className="selected-user">
            <h1>Selected Users</h1>
            {currentSelectedUsers.length > 0 ? (
              <div className="datagrid-holder">
                <table>
                  <thead>
                    <tr>
                      <th>BrgyId</th>
                      <th>First Name</th>
                      <th>Family Name</th>
                      <th>Gender</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentSelectedUsers.map((user, index) => (
                      <tr key={`${user.brgyId}-${index}`}>
                        <td>{user.brgyId}</td>
                        <td>{user.firstname}</td>
                        <td>{user.lastname}</td>
                        <td>{user.gender}</td>
                        <td
                          className="handleRemove"
                          onClick={() => handleRemove(index)}>
                          Remove
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-controls">
                  <button
                    className="pagination-button"
                    onClick={handlePreviousPageSelectedUsers}
                    disabled={currentPageSelectedUsers === 1}>
                    Previous
                  </button>
                  <span className="pagination-info">
                    Page {currentPageSelectedUsers} of{" "}
                    {Math.ceil(selectedUsers.length / rowsPerPage)}
                  </span>
                  <button
                    className="pagination-button"
                    onClick={handleNextPageSelectedUsers}
                    disabled={
                      currentPageSelectedUsers ===
                      Math.ceil(selectedUsers.length / rowsPerPage)
                    }>
                    Next
                  </button>
                </div>
              </div>
            ) : (
              <p className="noUsertext">No selected users.</p>
            )}
          </div>
        </div>
        <div className="group-case-info">
          <div className="cases-holder">
            <div className="form-group">
              <label htmlFor="Cases">Cases:</label>
              <select
                value={cases}
                onChange={(e) => setCases(e.target.value)}
                required>
                <option value="Settlement">Settlement</option>
                <option value="Blotter">Blotter</option>
                <option value="Crime">Crime</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="Status">Status:</label>
              <select
                value={casestatus}
                onChange={(e) => setCasestatus(e.target.value)}
                required>
                <option value="Active">Active</option>
                <option value="Ongoing">Ongoing</option>
                <option value="Settled">Settled</option>
              </select>
            </div>
            <div className="form-group">
              <label>Date:</label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Time:</label>
              <input
                type="time"
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Location:</label>
              <input
                type="text"
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                required
              />
            </div>
            <div className="form-group object">
              <label>Case Info:</label>
              <textarea
                value={caseinfo}
                onChange={(e) => setCaseinfo(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="addcases-parent-dashhboard wrap">
            <div className="addcasesdashhboard">
              <div className="child blottercases-parent">
                <div>
                  <label>Blotter</label>
                  <h3>{blotter}</h3>
                </div>
              </div>
              <div className="child all-crimecases-parent">
                <div>
                  <label>Crime</label>
                  <h3>{crime}</h3>
                </div>
              </div>
              <div className="child all-unsettledcases-parent">
                <div>
                  <label>Unsettled</label>
                  <h3>{settlement}</h3>
                </div>
              </div>
              <div className="child Settled Cases-parent">
                <div>
                  <label>Settled</label>
                  <h3>{settled}</h3>
                </div>
              </div>
              <div className="child all-Cases-parent">
                <div>
                  <label>All Cases</label>
                  <h3>{allcases}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="btn-container">
          <button className="submitbutton" onClick={handleSubmitCases}>
            Submit Case
          </button>
          <button
            type="btn"
            className="closebutton"
            onClick={handleclose} //close the page and back to login page
          >
            Close
          </button>
        </div>
      </div>
    </div>

    // </div>
  );
}

export default Addcase;
